import { useState, useEffect } from 'react';
import useScrollStore from '../../../../common/store/useScrollStore';

const useIcon = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => useScrollStore.subscribe(state => {
    if (-state.position >= 10) setVisible(false);
    else setVisible(true);
  }), []);

  return visible;
}

export default useIcon;